import React from 'react';
import { View } from '@amzn/atoz-web/View';
import { useShiftCardStatusData } from './useShiftCardStatusData';
import { InvisibleTestElement, StatusLine } from '../../shared';
export var ShiftCardStatus = function (props) {
    var statusLinePropsList = useShiftCardStatusData(props);
    if (statusLinePropsList.length === 0) {
        return (React.createElement(InvisibleTestElement, { dataTestId: "ShiftCardStatus_Empty", key: "ShiftCardStatus_Empty" }));
    }
    return (React.createElement(View, { dataTestId: "ShiftCardStatusList" }, statusLinePropsList.map(function (_a) {
        var dataTestId = _a.dataTestId, text = _a.text, alternativeTitle = _a.alternativeTitle, statusIcon = _a.statusIcon;
        return (React.createElement(StatusLine, { key: dataTestId, dataTestId: dataTestId, text: text, alternativeTitle: alternativeTitle, statusIcon: statusIcon }));
    })));
};
